import { Selector } from '@ngxs/store';
import { InnerWallBrickSettingsState } from '../brick-settings/specific-brick-settings/inner-wall-brick-settings/inner-wall-brick-settings.state';
import { TabBrickSettingsState } from '../brick-settings/specific-brick-settings/tab-brick-settings/tab-brick-settings.state';

export class LayoutBricksSelectors {
   @Selector([TabBrickSettingsState.getIsBrickInstanceHostingChildBrick, InnerWallBrickSettingsState.isBrickInstanceHostingChildBrick])
   public static getIsBrickInstanceHostingChildBrick(
      isTabBrickInstanceHostingChildBrick: (hostingBrickId: string, targetBrickId: string, deepCheckFn) => boolean,
      isInnerWallBrickInstanceHostingChildBrick: (hostingBrickId: string, targetBrickId: string, deepCheck) => boolean
   ) {
      const selectorFn = (hostingBrickId: string, targetBrickId: string, deepCheck = false) => {
         return (
            isTabBrickInstanceHostingChildBrick(hostingBrickId, targetBrickId, deepCheck ? selectorFn : null) ||
            isInnerWallBrickInstanceHostingChildBrick(hostingBrickId, targetBrickId, deepCheck ? selectorFn : null)
         );
      };
      return selectorFn;
   }

   @Selector([TabBrickSettingsState.getIsBrickInstancePartOfAnyTabBrick, InnerWallBrickSettingsState.isBrickInstancePartOfInnerWallBrickFn])
   public static getIsBrickMenuHandledByParentLayoutBrick(
      isBrickInstancePartOfTabBrickFn: (brickInstanceId: string) => boolean,
      isBrickInstancePartOfInnerWallBrickFn: (brickInstanceId: string) => boolean
   ): (brickInstanceId: string) => boolean {
      return (brickInstanceId: string) => {
         return isBrickInstancePartOfTabBrickFn(brickInstanceId) || isBrickInstancePartOfInnerWallBrickFn(brickInstanceId);
      };
   }

   @Selector([TabBrickSettingsState.getBrickInstanceIdOfParent, InnerWallBrickSettingsState.getBrickInstanceIdOfParentFn])
   public static getBrickInstanceIdOfParentFn(
      tabGetBrickInstanceIdOfParentFn: (brickInstanceId: string) => string,
      innerWallGetBrickInstanceIdOfParentFn: (brickInstanceId: string) => string
   ): (brickInstanceId: string) => string {
      return (brickInstanceId: string) => {
         return tabGetBrickInstanceIdOfParentFn(brickInstanceId) ?? innerWallGetBrickInstanceIdOfParentFn(brickInstanceId);
      };
   }
}
